import playButton from '../../icons/play.png';
import * as React from 'react';
import { styled } from '@mui/material/styles';

const Root = styled('div')`
  position: relative;
  > video {
    position: absolute;
    z-index: 2;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
  > div {
    transition: opacity 0.2s;
  }

  &.preview-mode {
    > video {
      opacity: 1;
    }
    > div {
      opacity: 0;
    }
  }
`;

export const VideoThumbnail = ({ imageUrl, title = '', width, preview, previewVideoUrl, format }) => {
  const adjustedWidth = format === 'horizontal' ? width : width * 0.66;
  const height = format === 'horizontal' ? adjustedWidth * 0.63 : adjustedWidth / 0.63;
  return (
    <Root sx={{ adjustedWidth, position: 'relative', aspectRatio: format === 'horizontal' ? '16 / 9' : '9 /' +
      ' 16' }} className={preview ? 'container preview-mode' : 'container'}>
      {previewVideoUrl && (
        <video width={adjustedWidth} height={height} controls={false} loop muted autoPlay>
          <source src={previewVideoUrl} type="video/mp4" />
        </video>
      )}
      <div
        style={{
          backgroundImage: `url(${imageUrl})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          borderRadius: '5%',
          aspectRatio: format === 'horizontal' ? '16 / 9' : '9 / 16'
        }}
      />
      <div title={title} className="play-icon">
        <img width={adjustedWidth} src={playButton} alt="play button" />
      </div>
    </Root>
  );
};

VideoThumbnail.defaultProps = {
  width: 90,
  preview: false,
  previewVideoUrl: null,
  format: 'horizontal',
};
